<template>
    <div>
        <div>
            <combo-slider :sliderData="sliderData"></combo-slider>
        </div>
        <div v-if="item!==null" style="margin: 0 auto;border-radius:10px;" class="row">
            <div class="col-xs-12">
                <div style="padding: 6px;border-radius: 10px; ">
                    <div style="font-weight:bold;font-size:2em;text-align:center;">{{item.title}}</div>
                    <div v-if="item !== null" style="text-align:center;">
                        <div style="white-space: pre-line; display: inline-block; margin: 0 auto;text-align:left;" v-html="html"></div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin:10px;">
                <div class="col-xs-12" v-if="videos.length>0" style="background: #f5f5f5;border-radius: 10px; ">
                    <div class="col-xs-12" :class="{'col-md-6':videos.length>1}" v-for="link in videos" style="padding-left: 0px; padding-right: 0px; background: #f5f5f5;border-radius: 10px; ">
                        <div style="display: inline-block;width:100%; ">
                            <media-link :item="link"></media-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin:10px;">
                <div :class="{'col-xs-12':links!==null && links.length===1, 'col-sm-6 col-md-6':links!==null && links.length>1}" v-for="link in links" style="border-radius: 10px; border: 1px solid white; height: 140px;">
                    <dual-link :item="link"></dual-link>
                </div>
            </div>

            <div class="col-xs-12">
                <paged-infos :init-filter="{prid:postId, cardView: 'dual',pageSize: 3,hidePaging: true }"></paged-infos>
            </div>
        </div>
    </div>
</template>
<script>

    import Loading from './base/Loading.vue';
    import comboSlider from './slider/Combo.vue';
    import PagedInfos from './PagedInfos.vue';
    import DualLink from './links/dualLink.vue';
    import mediaLink from './links/mediaLink.vue';

    export default {
        //props: ["apiClient", "postId"],
        props: ["postId"],
        components: {
            ComboSlider: comboSlider,
            Loading: Loading,
            PagedInfos: PagedInfos,
            DualLink: DualLink,
            mediaLink: mediaLink
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.articleDetailApiClient;
            },
            videos: function () {
                if (this.item && this.item.links !== null) {
                    return this.item.links.filter((it) => { return it.linkType === 1 });
                }
                return [];
            },
            links: function () {
                if (this.item && this.item.links !== null) {
                    return this.item.links.filter((it) => { return it.linkType === 0 });
                }
                return [];
            }
        },
        methods: {
            showOptions: function () {
                this.chooser.showOptions();
            },
            showDetail: function () {
                this.inView = "detail";
                this.html = this.item.textMsg;
            },
            showLabels: function () {
                var $that = this;
                this.inView = "label";
                this.apiClient.getPostCatLabelsPrms($that.postId).done(function (data) {
                    $that.html = data.responseText;
                });
            },
            showTags: function () {
                var $that = this;
                this.inView = "tag";
                this.apiClient.getPostTagsPrms($that.postId).done(function (data) {
                    $that.html = data.responseText;
                });
            },
            loadItem: function () {
                var $that = this;
                this.apiClient.getArticleByIdPrms($that.postId).done(function (data) {
                    $that.item = data;
                    $that.html = data.textMsg;
                    //$that.links = data.links;
                    if (data.images !== null && data.images.length > 0) {
                        var dt = data.images.map((item, index) => {
                            return { path: item.path, link: "", msg: item.textContent };
                        });
                        $that.sliderData = dt;
                    }

                });
            }
        },
        data: function () {
            return {
                item: null,
                html: "",
                chooser: null,
                sliderData: [],
                //links: [],
                inView: "detail"
            }
        },
        watch: {
            '$route'(to, from) {
                //this.loadItem();
            }
        },
        mounted: function () {
            this.loadItem();
        }
    }
</script>